import { Lucide } from "@react-native-vector-icons/lucide";
import type { ComponentProps } from "react";

import { iconSizes, useTheme, type ThemeColors } from "~/styles/theme";

type IconTone =
  "default" | "muted" | "inverse" | "primary" | "danger" | "success";

type IconProps = Omit<ComponentProps<typeof Lucide>, "size" | "color"> & {
  size?: keyof typeof iconSizes | number;
  tone?: IconTone;
  color?: string;
  label?: string;
};

function toneColor(tone: IconTone, colors: ThemeColors) {
  switch (tone) {
    case "muted":
      return colors.mutedForeground;
    case "inverse":
      return colors.background;
    case "primary":
      return colors.primaryForeground;
    case "danger":
      return colors.danger;
    case "success":
      return colors.success;
    default:
      return colors.heading;
  }
}

export function Icon({
  size = "md",
  tone = "default",
  color,
  label,
  ...props
}: IconProps) {
  const { colors } = useTheme();
  return (
    <Lucide
      size={typeof size === "number" ? size : iconSizes[size]}
      color={color ?? toneColor(tone, colors)}
      accessibilityLabel={label}
      accessible={Boolean(label)}
      {...props}
    />
  );
}
